import React, { useState, useEffect } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import LoadingOverlay from './LoadingOverlay';

const BonusManagement = () => {
    const [bonuses, setBonuses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editingBonus, setEditingBonus] = useState(null);
    const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
    const [selectedDays, setSelectedDays] = useState([]);
    const [activeTab, setActiveTab] = useState('configurations');
    const [bonusGames, setBonusGames] = useState([]);
    const [dailyStats, setDailyStats] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)), // Last 7 days
        endDate: new Date()
    });
    const [presets, setPresets] = useState([]);
    const [showPresetModal, setShowPresetModal] = useState(false);
    const [editingPreset, setEditingPreset] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        bonusType: 'fixed',
        bonusValue: 0,
        startDateTime: '',
        endDateTime: '',
        gameType: 'regular',
        minPlayers: 0,
        description: '',
        maxBonusAmount: null,
        triggerType: 'time-based',
        triggerValue: 0,
        dailyBonusLimit: null,
        bonusPool: 0,
        minBonusAmount: null,
        maxBonusAmount: null,
        remainingBonusPool: 0
    });
    const [currentServerTime, setCurrentServerTime] = useState(null);

    const [presetForm, setPresetForm] = useState({
        name: '',
        bonusType: 'fixed',
        bonusValue: 0,
        gameType: 'regular',
        minPlayers: 0,
        description: '',
        maxBonusAmount: null,
        presetCategory: 'daily',
        isGlobalPreset: false,
        presetPriority: 0
    });
    const [serverTimeOffset, setServerTimeOffset] = useState(0);
    const days = ['እሁድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'አርብ', 'ቅዳሜ']
    const API = process.env.REACT_APP_API;

    useEffect(() => {
        const syncServerTime = async () => {
            try {
                const response = await api.get(`${API}/current`);
                const serverTime = new Date(response.currentTime);
                const localTime = new Date();
                setServerTimeOffset(serverTime.getTime() - localTime.getTime());
            } catch (error) {
                console.error('Error syncing server time:', error);
                toast.error('Failed to sync time with server');
            }
        };
        syncServerTime();
    }, []);


    const bonusTypes = [
        { label: 'ቋሚ መጠን', value: 'fixed' },
        { label: 'በመቶኛ', value: 'percentage' },
        { label: 'ማባዣ', value: 'multiplier' }
    ];

    const fetchServerTime = async () => {
        try {
            const response = await api.get(`${API}/current`);
            console.log(response)
            const serverTime = new Date(response.currentTime);
            return serverTime;
        } catch (error) {
            console.error('Error fetching server time:', error);
            toast.error('Failed to sync time with server');
            return new Date(); // Fallback to local time
        }
    };

    const ToggleSwitch = ({ isActive, onToggle }) => {
        return (
          <div 
            onClick={onToggle}
            className={`mt-1 relative w-24 h-10 rounded-full cursor-pointer transition-colors duration-300 ease-in-out
              ${isActive ? 'bg-success' : 'bg-red-800'}`}
          >
            <span 
              className={`absolute text-xs font-medium ${isActive ? 'right-3.5' : 'left-3.5'} top-3.5
                ${isActive ? 'text-white-600' : 'text-gray-400'}`}
            >
              {isActive ? 'ON' : 'OFF'}
            </span>
          </div>
        );
      };

    const convertToEthiopianTime = (hours, minutes) => {
        let ethiopianHours;
        let period;

        if (hours >= 6 && hours < 12) {
            ethiopianHours = hours - 6;
            period = 'ሰዓት ጥዋት';
        } else if (hours >= 12 && hours < 18) {
            ethiopianHours = hours - 6;
            period = 'ሰዓት ቀን';
        } else if (hours >= 18 && hours < 24) {
            ethiopianHours = hours - 18;
            period = 'ሰዓት ማታ';
        } else {
            ethiopianHours = hours + 6;
            period = 'ሰዓት ሌሊት';
        }
        if (ethiopianHours === 0) {
            ethiopianHours = 12;
        }
    
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${ethiopianHours}:${formattedMinutes} ${period}`;
    };
    
    const convertFromEthiopianTime = (ethiopianHour, period) => {
        switch(period) {
          case 'ጥዋት':
            return ethiopianHour + 6; // 1-6 ጥዋት -> 7-12 standard
          case 'ቀን':
            return ethiopianHour + 6; // 6-12 ቀን -> 12-18 standard
          case 'ማታ':
            return ethiopianHour + 18; // 1-6 ማታ -> 19-24 standard
          case 'ሌሊት':
            return ethiopianHour - 6; // 7-12 ሌሊት -> 1-6 standard
          default:
            return ethiopianHour;
        }
    };
    
    const formatDateTime = (dateStr, dateOnly = false) => {
        if (!dateStr) return '';
        
        const date = new Date(dateStr);
        const days = ['እሁድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'አርብ', 'ቅዳሜ'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        const year = date.getFullYear();
        const month = months[date.getMonth()];
        const day = date.getDate();
        const dayOfWeek = days[date.getDay()];
        const hours = date.getHours();
        const minutes = date.getMinutes();

        if (dateOnly) {
            return `${dayOfWeek}፣ ${month} ${day}፣ ${year}`;
        }

        const ethiopianTime = convertToEthiopianTime(hours, minutes);
        return `${dayOfWeek} ${month} ${day} ${year} ${ethiopianTime}`;
    };
    
    const handleDelete = async (id) => {
        if (!window.confirm('እርግጠኛ ነዎት ይህን ቦነስ መሰረዝ ይፈልጋሉ?')) {
            return;
        }

        setLoading(true);
        try {
            await api.delete(`${API}/bonus/${id}`);
            toast.success('ቦነስ በተሳካ ሁኔታ ተሰርዟል');
            fetchBonuses();
        } catch (error) {
            toast.error(error.response?.message || 'ቦነስን ለመሰረዝ አልተሳካም');
            console.error('Error deleting bonus:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBonuses();
        fetchPresets();
    }, []);

    useEffect(() => {
        if (activeTab === 'daily-stats') {
          fetchDailyStats();
        }
    }, [activeTab, dateRange]);

    const fetchBonuses = async () => {
        setLoading(true);
        try {
            const response = await api.get(`${API}/bonus/list`);
            setBonuses(response);
        } catch (error) {
            toast.error('ቦነሶችን ለማግኘት አልተሳካም');
        } finally {
            setLoading(false);
        }
    };

    const fetchPresets = async () => {
        try {
            const response = await api.get(`${API}/bonus/presets`);
            setPresets(response);
        } catch (error) {
            toast.error('Failed to fetch presets');
        }
    };

    const handlePresetSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (editingPreset) {
                await api.put(`${API}/bonus/preset/${editingPreset._id}`, presetForm);
                toast.success('Preset updated successfully');
            } else {
                await api.post(`${API}/bonus/preset`, presetForm);
                toast.success('Preset created successfully');
            }
            setShowPresetModal(false);
            resetPresetForm();
            fetchPresets();
        } catch (error) {
            toast.error(error.response?.message || 'Failed to save preset');
        } finally {
            setLoading(false);
        }
    };

    const togglePreset = async (presetId) => {
        try {
            setIsLoading(true)
            const response = await api.put(`${API}/bonus/preset/${presetId}/toggle`);
            
            if (response) {
                fetchPresets();
                toast.success('Preset status updated successfully');
                setActiveTab('presets')
            }
        } catch (error) {
            console.error('Error toggling preset:', error);
            toast.error(error.response?.message || 'Failed to toggle preset');
        } finally {
            setIsLoading(false)
        }
    };

    const resetPresetForm = () => {
        setPresetForm({
            name: '',
            bonusType: 'fixed',
            bonusValue: 0,
            gameType: 'regular',
            minPlayers: 0,
            description: '',
            maxBonusAmount: null,
            presetCategory: 'daily',
            isGlobalPreset: false,
            presetPriority: 0
        });
        setEditingPreset(null);
    };

    const fetchDailyStats = async () => {
        try {
            const params = new URLSearchParams({
            startDate: dateRange.startDate.toISOString(),
            endDate: dateRange.endDate.toISOString()
            });
            const response = await api.get(`${API}/bonus/daily-stats?${params}`);
            setDailyStats(response);
        } catch (error) {
            toast.error('Failed to fetch daily bonus statistics');
        }
    };

    const handleTimeSlotChange = (timeSlot) => {
        setSelectedTimeSlots(prev => 
            prev.includes(timeSlot) 
                ? prev.filter(t => t !== timeSlot)
                : [...prev, timeSlot]
        );
    };

    const handleDaySelection = (day) => {
        setSelectedDays(prev => 
            prev.includes(day)
                ? prev.filter(d => d !== day)
                : [...prev, day]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const serverTime = await fetchServerTime();
            const bonusData = {
                ...formData,
                selectedDays,
                selectedTimeSlots
            };

            if (editingBonus) {
                await api.put(`${API}/bonus/${editingBonus._id}`, bonusData);
                toast.success('ቦነስ በተሳካ ሁኔታ ተዘምኗል');
            } else {
                await api.post(`${API}/bonus/create`, bonusData);
                toast.success('ቦነስ በተሳካ ሁኔታ ተፈጥሯል');
            }
            setShowModal(false);
            resetForm();
            fetchBonuses();
        } catch (error) {
            toast.error(error.response?.message || 'ቦነስ ለመፍጠር አልተሳካም');
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setFormData({
            name: '',
            bonusType: 'fixed',
            bonusValue: 0,
            startDateTime: '',
            endDateTime: '',
            gameType: 'regular',
            minPlayers: 0,
            description: '',
            maxBonusAmount: null,
            triggerType: 'time-based',
            triggerValue: 0,
            dailyBonusLimit: null,
            bonusPool: 0,
            minBonusAmount: null,
            maxBonusAmount: null,
            remainingBonusPool: 0
        });
        setSelectedDays([]);
        setSelectedTimeSlots([]);
        setEditingBonus(null);
    };

    useEffect(() => {
        if (activeTab === 'games') {
          fetchBonusGames();
        }
      }, [activeTab]);
    
    const fetchBonusGames = async () => {
    try {
        const response = await api.get(`${API}/bonus/bonus-games`);
        setBonusGames(response);
    } catch (error) {
        console.error('Error fetching bonus games:', error);
        toast.error('Failed to fetch bonus games');
    }
    };

    return (
        <div className="p-4 bg-teal-800 min-h-screen">
            {isLoading && <LoadingOverlay />}
            <div className="mb-2">
                <button
                className={`mr-2 px-4 py-2 rounded ${activeTab === 'configurations' ? 'bg-teal-600 text-white' : 'bg-gray-200'}`}
                onClick={() => setActiveTab('configurations')}
                >
                የቦነስ ማስተካከያዎች
                </button>
                <button
                className={`px-4 py-2 rounded ${activeTab === 'games' ? 'bg-teal-600 text-white' : 'bg-gray-200'}`}
                onClick={() => setActiveTab('games')}
                >
                ቦነስ ያላቸው ጨዋታዎች ታሪክ
                </button>
                <button
                className={`ml-2 px-4 py-2 rounded ${activeTab === 'daily-stats' ? 'bg-teal-600 text-white' : 'bg-gray-200'}`}
                onClick={() => setActiveTab('daily-stats')}
                >
                የዕለት ስታትስቲክስ
                </button>
                <button
                    className={`ml-2 px-4 py-2 rounded ${activeTab === 'presets' ? 'bg-teal-600' : 'bg-gray-200'}`}
                    onClick={() => setActiveTab('presets')}
                >
                የቦነስ ቅድመ ማስተካከያዎች
                </button>
            </div>

        {activeTab === 'configurations' ? (
          <div className="max-w-7xl mx-auto">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl text-white font-bold">የቦነስ አስተዳደር</h1>
                <button
                    onClick={() => setShowModal(true)}
                    className="bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700"
                >
                    አዲስ ቦነስ ፍጠር
                </button>
            </div>

            {loading ? (
                <div className="text-center py-4 text-white">በመጫን ላይ...</div>
            ) : bonuses?.length === 0 ? (
                <div className="text-gray-400">ምንም ቦነሶች አልተገኙም</div>
            ) : (
                <div className="grid gap-1">
                    {bonuses?.map((bonus) => (
                        <div
                            key={bonus._id}
                            className="bg-teal-900 rounded-lg py-3 px-4"
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="flex justify-between items-center">
                                    <h6 className="text-white font-semibold">{bonus.name}:  </h6>
                                    <div className='ml-2'>  </div>
                                    <h6 className="text-white font-semibold">
                                        {formatDateTime(bonus.startDateTime)} - {formatDateTime(bonus.endDateTime)}
                                    </h6>
                                    </div>
                                    <div className="flex items-center">
                                        <button className="bg-teal-600 text-white fw-bold text-sm p-2 bg-teal-600 border-none">
                                            ዓይነት: {bonus.bonusType === 'fixed' ? 'ቋሚ መጠን' : 
                                                    bonus.bonusType === 'percentage' ? 'በመቶኛ' : 'ማባዣ'}
                                        </button>
                                        <button className="bg-teal-600 text-white text-sm ml-2 p-2 fw-bold">
                                            {bonus.triggerType === 'time-based' ? 'በሰዓት መሰረት ቦነስ' : 
                                            bonus.triggerType === 'games-count' ? `በየ ${bonus.triggerValue} ጨዋታ ቦነስ` :
                                            bonus.triggerType === 'bet-amount' ? `የቀን ውርርድ ${bonus.triggerValue} ብር ሲደርስ ቦነስ` :
                                            bonus.triggerType === 'profit-threshold' ? `የቀን ትርፍ ${bonus.triggerValue} ብር ሲደርስ ቦነስ` :
                                            'ገንዘብ መጠን ቦነስ'}
                                        </button>
                                        {bonus.bonusValue && bonus.bonusValue  !==0 &&
                                            <button className="bg-teal-600 text-white text-sm ml-2 p-2 fw-bold">
                                                መጠን: {bonus.bonusValue}
                                                {bonus.bonusType === 'percentage' ? '%' : 
                                                bonus.bonusType === 'multiplier' ? 'x' : ' ብር'}
                                            </button>
                                        }
                                        {bonus.triggerType === 'bonus-pool' && (
                                            <button className="bg-teal-600 text-white text-sm ml-2 p-2 fw-bold">ቀሪ/የዛሬ ቦነስ : {bonus.remainingBonusPool} / {bonus.bonusPool} ብር</button> 
                                        )}
                                        {bonus.dailyBonusLimit && (
                                            <button className="bg-teal-600 text-white text-sm ml-2 p-2 fw-bold">ገደብ: {bonus.distributedCount || 0} / {bonus.dailyBonusLimit}</button>
                                        )}
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => {
                                            setEditingBonus(bonus);
                                            setFormData(bonus);
                                            setShowModal(true);
                                        }}
                                        className="bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700"
                                    >
                                        አስተካክል
                                    </button>
                                    <button
                                        onClick={() => handleDelete(bonus._id)}
                                        className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                                    >
                                        ሰርዝ
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {showModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 z-50">
                        <div className="bg-gray-800 p-3 w-full max-w-xl">
                            <div className="flex justify-between items-center mb-1">
                                <h2 className="text-xl text-white font-bold">
                                    {editingBonus ? 'ቦነስ አስተካክል' : 'አዲስ ቦነስ ፍጠር'}
                                </h2>
                                <button
                                    onClick={() => {
                                        setShowModal(false);
                                        resetForm();
                                    }}
                                    className="text-gray-400 hover:text-white"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-3">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div>
                                        <label className="block text-white mb-1 text-sm">የቦነስ ስም</label>
                                        <input
                                            type="text"
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            className="w-full bg-gray-700 text-white p-1.5 rounded text-sm"
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-white mb-1 text-sm">የቦነስ ዓይነት</label>
                                        <select
                                            value={formData.bonusType}
                                            onChange={(e) => setFormData({ ...formData, bonusType: e.target.value })}
                                            className="w-full bg-gray-700 text-white p-1.5 rounded text-sm"
                                            required
                                        >
                                            {bonusTypes.map(type => (
                                                <option key={type.value} value={type.value}>
                                                    {type.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-white mb-1 text-sm">
                                            {formData.bonusType === 'fixed' ? 'የቦነስ መጠን (ብር)' :
                                            formData.bonusType === 'percentage' ? 'የቦነስ መጠን (%)' :
                                            'የቦነስ ማባዣ (x)'}
                                        </label>
                                        <input
                                            type="number"
                                            value={formData.bonusValue}
                                            onChange={(e) => setFormData({ ...formData, bonusValue: parseFloat(e.target.value) })}
                                            className="w-full bg-gray-700 text-white p-1.5 rounded text-sm"
                                            required
                                            min={0}
                                            step={formData.bonusType === 'percentage' ? '0.1' : '1'}
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-1 gap-3">
                                    <div>
                                        <label className="block text-white mb-1 text-sm">መጀመሪያ ጊዜ</label>
                                        <div className="grid grid-cols-9 gap-2">
                                            <input
                                            type="date"
                                                value={formData.startDateTime.split('T')[0]}
                                                onClick={(e) => e.target.showPicker()}
                                                onChange={(e) => setFormData(prev => ({
                                                    ...prev,
                                                    startDateTime: `${e.target.value}T${prev.startDateTime.split('T')[1] || '00:00'}`
                                                }))}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            />
                                            <select
                                                value={formData.startDateTime.split('T')[1]?.split(':')[0] || ''}
                                                onChange={(e) => {
                                                    const hour = e.target.value.padStart(2, '0');
                                                    const minutes = formData.startDateTime.split('T')[1]?.split(':')[1] || '00';
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        startDateTime: `${prev.startDateTime.split('T')[0]}T${hour}:${minutes}`
                                                    }));
                                                }}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            >
                                                <option value="">ሰዓት</option>
                                                <optgroup label="ጥዋት">
                                                    {[1,2,3,4,5,6].map(hour => (
                                                        <option key={hour} value={(hour + 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ጥዋት
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ቀን">
                                                    {[6,7,8,9,10,11,12].map(hour => (
                                                        <option key={hour} value={(hour + 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ቀን
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ማታ">
                                                    {[1,2,3,4,5,6].map(hour => (
                                                        <option key={hour} value={(hour === 12 ? 18 : hour + 18).toString().padStart(2, '0')}>
                                                            {hour}:00 ማታ
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ሌሊት">
                                                    {[7,8,9,10,11,12].map(hour => (
                                                        <option key={hour} value={(hour - 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ሌሊት
                                                        </option>
                                                    ))}
                                                </optgroup>
                                            </select>
                                            <select
                                                value={formData.startDateTime.split('T')[1]?.split(':')[1] || ''}
                                                onChange={(e) => {
                                                    const hour = formData.startDateTime.split('T')[1]?.split(':')[0] || '00';
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        startDateTime: `${prev.startDateTime.split('T')[0]}T${hour}:${e.target.value}`
                                                    }));
                                                }}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            >
                                                <option value="">ደቂቃ</option>
                                                {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(minute => (
                                                    <option key={minute} value={minute.toString().padStart(2, '0')}>
                                                        {minute}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <label className="block text-white mb-1 text-sm">መጨረሻ ጊዜ</label>
                                        <div className="grid grid-cols-9 gap-2">
                                            <input
                                                type="date"
                                                value={formData.endDateTime.split('T')[0]}
                                                onClick={(e) => e.target.showPicker()}
                                                onChange={(e) => setFormData(prev => ({
                                                    ...prev,
                                                    endDateTime: `${e.target.value}T${prev.endDateTime.split('T')[1] || '00:00'}`
                                                }))}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            />
                                            <select
                                                value={formData.endDateTime.split('T')[1]?.split(':')[0] || ''}
                                                onChange={(e) => {
                                                    const hour = e.target.value.padStart(2, '0');
                                                    const minutes = formData.endDateTime.split('T')[1]?.split(':')[1] || '00';
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        endDateTime: `${prev.endDateTime.split('T')[0]}T${hour}:${minutes}`
                                                    }));
                                                }}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            >
                                                <option value="">ሰዓት</option>
                                                <optgroup label="ጥዋት">
                                                    {[1,2,3,4,5,6].map(hour => (
                                                        <option key={hour} value={(hour + 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ጥዋት
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ቀን">
                                                    {[6,7,8,9,10,11,12].map(hour => (
                                                        <option key={hour} value={(hour + 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ቀን
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ማታ">
                                                    {[1,2,3,4,5,6].map(hour => (
                                                        <option key={hour} value={(hour === 12 ? 18 : hour + 18).toString().padStart(2, '0')}>
                                                            {hour}:00 ማታ
                                                        </option>
                                                    ))}
                                                </optgroup>
                                                <optgroup label="ሌሊት">
                                                    {[7,8,9,10,11,12].map(hour => (
                                                        <option key={hour} value={(hour - 6).toString().padStart(2, '0')}>
                                                            {hour}:00 ሌሊት
                                                        </option>
                                                    ))}
                                                </optgroup>
                                            </select>
                                            <select
                                                value={formData.endDateTime.split('T')[1]?.split(':')[1] || ''}
                                                onChange={(e) => {
                                                    const hour = formData.endDateTime.split('T')[1]?.split(':')[0] || '00';
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        endDateTime: `${prev.endDateTime.split('T')[0]}T${hour}:${e.target.value}`
                                                    }));
                                                }}
                                                className="col-span-3 bg-gray-700 text-white p-1.5 rounded text-sm"
                                                required
                                            >
                                                <option value="">ደቂቃ</option>
                                                {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].map(minute => (
                                                    <option key={minute} value={minute.toString().padStart(2, '0')}>
                                                        {minute}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div>
                                        <label className="block text-white mb-1 text-sm">ዝቅተኛ የተጫዋቾች ብዛት</label>
                                        <input
                                            type="number"
                                            value={formData.minPlayers}
                                            onChange={(e) => setFormData({ ...formData, minPlayers: parseInt(e.target.value) })}
                                            className="w-full bg-gray-700 text-white p-1.5 rounded text-sm"
                                            min="0"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-white mb-1 text-sm">ከፍተኛ የቦነስ መጠን</label>
                                        <input
                                            type="number"
                                            value={formData.maxBonusAmount || ''}
                                            onChange={(e) => setFormData({ 
                                                ...formData, 
                                                maxBonusAmount: e.target.value ? parseFloat(e.target.value) : null 
                                            })}
                                            className="w-full bg-gray-700 text-white p-1.5 rounded text-sm"
                                            min="0"
                                            placeholder="አማራጭ"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-white">ዓይነት</label>
                                        <select
                                            className="w-full p-2 bg-gray-700 rounded text-white"
                                            value={formData.triggerType}
                                            onChange={(e) => setFormData({...formData, triggerType: e.target.value})}
                                            required
                                        >
                                            <option value="time-based">በጊዜ ላይ የተመሰረተ</option>
                                            <option value="games-count">በጨዋታ ብዛት</option>
                                            <option value="bet-amount">በመደብ መጠን</option>
                                            <option value="profit-threshold">በትርፍ ገደብ</option>
                                            <option value="bonus-pool">የቦነስ ጥምር</option>
                                        </select>
                                    </div>
                                </div>

                                {formData.triggerType !== 'time-based' && (
                                    <div className="grid grid-cols-2 gap-4 mb-1 text-white">
                                        <div>
                                            <label className="block">
                                                {formData.triggerType === 'games-count' && 'የጨዋታ ብዛት'}
                                                {formData.triggerType === 'bet-amount' && 'የመደብ መጠን (ብር)'}
                                                {formData.triggerType === 'profit-threshold' && 'የትርፍ ገደብ ማስጀመሪያ (ብር)'}
                                            </label>
                                            {formData.triggerType !== 'bonus-pool' && (
                                                <input
                                                    type="number"
                                                    className="w-full p-2 bg-gray-700 rounded"
                                                    value={formData.triggerValue}
                                                    onChange={(e) => setFormData({...formData, triggerValue: parseFloat(e.target.value)})}
                                                    min="0"
                                                    required
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className="mb-1 mt-0">
                                    <label className="block mb-1 text-white">የዕለት የቦነስ ገደብ</label>
                                    <input
                                        type="number"
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={formData.dailyBonusLimit || ''}
                                        onChange={(e) => setFormData({...formData, dailyBonusLimit: e.target.value ? parseInt(e.target.value) : null})}
                                        min="0"
                                    />
                                </div>

                                {formData.triggerType === 'bonus-pool' && (
                                    <div className="flex gap-4 mb-4">
                                        <div>
                                            <label className="block text-white">የቦነስ ጥምር መጠን</label>
                                            <input
                                                type="number"
                                                className="w-full p-2 bg-gray-700 rounded"
                                                value={formData.bonusPool}
                                                onChange={(e) => setFormData({...formData, bonusPool: parseFloat(e.target.value)})}
                                                min="0"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-white">ዝቅተኛ ቦነስ</label>
                                            <input
                                                type="number"
                                                className="w-full p-2 bg-gray-700 rounded"
                                                value={formData.minBonusAmount || ''}
                                                onChange={(e) => setFormData({...formData, minBonusAmount: e.target.value ? parseFloat(e.target.value) : null})}
                                                min="0"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-white">ዝቅተኛ ቦነስ</label>
                                            <input
                                                type="number"
                                                className="w-full p-2 bg-gray-700 rounded"
                                                value={formData.maxBonusAmount || ''}
                                                onChange={(e) => setFormData({...formData, maxBonusAmount: e.target.value ? parseFloat(e.target.value) : null})}
                                                min="0"
                                                required
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowModal(false);
                                            resetForm();
                                        }}
                                        className="px-3 py-1.5 bg-gray-600 text-white rounded text-sm hover:bg-gray-700"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 disabled:opacity-50"
                                        disabled={loading}
                                    >
                                        {loading ? 'በማስቀመጥ ላይ...' : editingBonus ? 'አስተካክል' : 'ፍጠር'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
            )}
          </div>
        ): activeTab === 'games' &&(
            <div className="bg-teal-800 rounded-lg p-4">
            <h2 className="text-xl font-bold mb-4 text-white">ቦነስ የተሰጣቸው ጨዋታዎች</h2>
            <div className="overflow-x-auto">
                <table className="w-full text-white">
                <thead>
                    <tr className="bg-teal-700">
                    <th className="p-2">ቀን</th>
                    <th className="p-2">ደራሽ</th>
                    <th className="p-2">ጠቅላላ ቦነስ</th>
                    <th className="p-2">የተሰጡ ቦነሶች ዝርዝር</th>
                    </tr>
                </thead>
                <tbody>
                    {bonusGames.map(game => (    
                    <tr key={game.gameId} className="border-t border-gray-700">
                        <td className="p-2">
                        {formatDateTime(game.date)}
                        </td>
                        <td className="p-2">{game.baseAmount} Birr</td>
                        <td className="p-2">{game.totalBonusAmount} Birr</td>
                        <td className="p-2">
                        <ul className="list-disc pl-4">
                            {game.appliedBonuses.map((bonus, index) => (
                            <p className="mt-1" key={index}>
                                {bonus.bonusAmount} Birr 
                                {bonus.bonusType === 'percentage' ? `(${bonus.bonusValue}%)` : 
                                bonus.bonusType === 'multiplier' ? `(${bonus.bonusValue}x)` : 
                                ``}
                            </p>
                            ))}
                        </ul>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            </div>
        )}
        {activeTab === 'daily-stats' && (
          <div className="bg-teal-700 rounded-lg p-4">
            <div className="mb-4 flex space-x-4">
                <div>
                <label className="block text-white mb-2">ከቀን</label>
                <input
                    type="date"
                    className="p-2 rounded"
                    value={dateRange.startDate.toISOString().split('T')[0]}
                    onChange={(e) => setDateRange(prev => ({
                    ...prev,
                    startDate: new Date(e.target.value)
                    }))}
                />
                </div>
                <div>
                <label className="block text-white mb-2">እስከ ቀን</label>
                <input
                    type="date"
                    className="p-2 rounded"
                    value={dateRange.endDate.toISOString().split('T')[0]}
                    onChange={(e) => setDateRange(prev => ({
                    ...prev,
                    endDate: new Date(e.target.value)
                    }))}
                />
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full text-white">
                <thead>
                    <tr className="bg-teal-800">
                    <th className="p-2">ቀን</th>
                    <th className="p-2">ጠቅላላ የቦነስ ጨዋታዎች</th>
                    <th className="p-2">ጠቅላላ የቦነስ መጠን</th>
                    </tr>
                </thead>
                <tbody>
                    {dailyStats.map((stat) => (
                    <tr key={stat.date} className="border-t border-gray-700">
                        <td className="p-2">{formatDateTime(stat.date, true)}</td>
                        <td className="p-2">{stat.totalGames}</td>
                        <td className="p-2">{stat.totalBonusAmount.toFixed(2)} Birr</td>
                    </tr>
                    ))}
                </tbody>
                <tfoot className="bg-teal-900">
                    <tr>
                    <td className="p-2 font-bold">Total</td>
                    <td className="p-2 font-bold">
                        {dailyStats.reduce((sum, stat) => sum + stat.totalGames, 0)}
                    </td>
                    <td className="p-2 font-bold">
                        {dailyStats.reduce((sum, stat) => sum + stat.totalBonusAmount, 0).toFixed(2)} Birr
                    </td>
                    <td></td>
                    </tr>
                </tfoot>
                </table>
            </div>
            </div>
        )}
        {activeTab === 'presets' && (
            <div className="grid gap-4 text-white">
                <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-white">ቅድመ ዝግጅቶች</h2>
                <button
                className="bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700"
                onClick={() => setShowPresetModal(true)}
                >
                    ቅድመ ዝግጅት ፍጠር
                </button>
                </div>
                {presets.map((preset) => (
                    <div key={preset._id} className="bg-teal-900 p-4 rounded-lg">
                        <div className="flex justify-between items-center">
                            <div>
                                <h3 className="text-xl font-bold">{preset.name}</h3>
                                <p className="mt-2">
                                    {preset.bonusType === 'fixed' && `Fixed bonus: ${preset.bonusValue}`}
                                    {preset.bonusType === 'percentage' && `Percentage: ${preset.bonusValue}%`}
                                    {preset.bonusType === 'multiplier' && `Multiplier: ${preset.bonusValue}x`}
                                </p>
                            </div>
                            <div className="flex space-x-2">
                                <ToggleSwitch 
                                  isActive={preset.isActive}
                                  onToggle={() => togglePreset(preset._id)}
                                />
                                <button
                                    className="bg-teal-600 px-4 py-2 rounded"
                                    onClick={() => {
                                        setEditingPreset(preset);
                                        setPresetForm({
                                            name: preset.name,
                                            bonusType: preset.bonusType,
                                            bonusValue: preset.bonusValue,
                                            gameType: preset.gameType,
                                            minPlayers: preset.minPlayers,
                                            description: preset.description,
                                            maxBonusAmount: preset.maxBonusAmount,
                                            presetCategory: preset.presetCategory,
                                            isGlobalPreset: preset.isGlobalPreset,
                                            presetPriority: preset.presetPriority
                                        });
                                        setShowPresetModal(true);
                                    }}
                                >
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )}
        {showPresetModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 text-white flex items-center justify-center">
                <div className="bg-teal-900 p-6 rounded-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
                    <h2 className="text-xl font-bold mb-4">
                        {editingPreset ? 'አዘምን' : 'ፍጠር'}
                    </h2>
                    <form onSubmit={handlePresetSubmit}>
                        <div className="space-y-4">
                            {/* Basic Information */}
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1">ስም</label>
                                    <input
                                        type="text"
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.name}
                                        onChange={(e) => setPresetForm({...presetForm, name: e.target.value})}
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block mb-1">ዓይነት</label>
                                    <select
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.bonusType}
                                        onChange={(e) => setPresetForm({...presetForm, bonusType: e.target.value})}
                                        required
                                    >
                                        <option value="fixed">ቋሚ መጠን</option>
                                        <option value="percentage">በመቶኛ</option>
                                        <option value="multiplier">ማባዣ</option>
                                    </select>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1">
                                        {presetForm.bonusType === 'fixed' ? 'Bonus Amount' :
                                        presetForm.bonusType === 'percentage' ? 'Percentage Value' :
                                        'Multiplier Value'}
                                    </label>
                                    <input
                                        type="number"
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.bonusValue}
                                        onChange={(e) => setPresetForm({...presetForm, bonusValue: parseFloat(e.target.value)})}
                                        step={presetForm.bonusType === 'percentage' ? '0.1' : '1'}
                                        min={presetForm.bonusType === 'multiplier' ? '1' : '0'}
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="block mb-1">ከፍተኛ ቦነስ</label>
                                    <input
                                        type="number"
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.maxBonusAmount || ''}
                                        onChange={(e) => setPresetForm({...presetForm, maxBonusAmount: e.target.value ? parseFloat(e.target.value) : null})}
                                        min="0"
                                    />
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-1">ዝቅተኛ ተጫዋቾች</label>
                                    <input
                                        type="number"
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.minPlayers}
                                        onChange={(e) => setPresetForm({...presetForm, minPlayers: parseInt(e.target.value)})}
                                        min="0"
                                        required
                                    />
                                </div>

                                {/* Preset Specific Settings */}
                                <div>
                                    <label className="block mb-1">የቅድመ ዝግጅት ምድብ</label>
                                    <select
                                        className="w-full p-2 bg-gray-700 rounded"
                                        value={presetForm.presetCategory}
                                        onChange={(e) => setPresetForm({...presetForm, presetCategory: e.target.value})}
                                        required
                                    >
                                        <option value="daily">የዕለት ቦነስ</option>
                                        <option value="weekend">የሳምንት መጨረሻ ልዩ</option>
                                        <option value="holiday">የበዓል ቦነስ</option>
                                        <option value="special">ልዩ ዝግጅት</option>
                                    </select>
                                </div>
                            </div>

                            {/* <div className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="isGlobalPreset"
                                    className="w-4 h-4"
                                    checked={presetForm.isGlobalPreset}
                                    onChange={(e) => setPresetForm({...presetForm, isGlobalPreset: e.target.checked})}
                                />
                                <label htmlFor="isGlobalPreset">
                                    Make this a global preset (available to all admins)
                                </label>
                            </div> */}

                            {/* Form Actions */}
                            <div className="flex justify-end gap-2 pt-4">
                                <button
                                    type="button"
                                    className="px-4 py-2 bg-gray-600 rounded hover:bg-gray-700"
                                    onClick={() => {
                                        setShowPresetModal(false);
                                        resetPresetForm();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-primary rounded hover:bg-gray"
                                    disabled={loading}
                                >
                                    ፍጠር
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )}
    </div>
  );
};

export default BonusManagement;